import { createAction } from 'redux-actions';
import * as types from './actionTypes';
import {
  updateConsultationFee
} from '../../utils/api';

// common
export const putRequest = createAction(types.PUT_REQUEST)
export const putSuccess = createAction(types.PUT_SUCCESS)
export const putFailure = createAction(types.PUT_FAILURE)

export function doUpdateFee(consultationId, isTaxabled, taxAmount, consultFee, estimatedFee, payDate, taxYear, taxVoucher, receiptName, receiptCategory, receiptNote, receiptDate, receiptCost, receiptReason) {
  return dispatch => {
    dispatch(putRequest());
    updateConsultationFee(consultationId, isTaxabled, taxAmount, consultFee, estimatedFee, payDate, taxYear, taxVoucher, receiptName, receiptCategory, receiptNote, receiptDate, receiptCost, receiptReason).then(data => {
      dispatch(putSuccess());
    }).catch((errMsg) => {
      dispatch(putFailure({ errMsg }));
    })
  }
}